import React, { useEffect, useCallback, useState } from "react";
import {
  Backdrop,
  Button,
  Divider,
  FormFieldSet,
  LogoLoader,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
  showToast,
  AttachmentSection,
  DocumentsList,
} from "../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { WADocStatus } from "../../../../../../assets/data/enumData";
import { WADocType } from "../../../../../../assets/data/projectData";
//
import { useDispatch, useSelector } from "react-redux";
import { updateEmployee } from "../../../../../../redux/slices/employee/employeeApi";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../../../redux/slices/employee/employeeSlice";
//

//Get Login User data
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { transformFiles } from "../../../../../../utils/transformFiles";
//Get Login User data end

const I94Modal = ({ isOpen, onClose, edit, selectedRow }) => {
  const dispatch = useDispatch();
  const [validationRules, setValidationRules] = useState({});
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const { i94 } = currentEmployee.employeeDetails || {};

  // Get the current i94 array length for new entries or use edit index
  const currentI94Length = i94?.i94?.length || 0;
  const documentIndex = edit?.index ?? currentI94Length;
  ///Get login user informatio
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  //////////////////
  //initial Form Data

  const initialFormData = {
    i94number: "",
    mostRecentDateOfEntry: "",
    admitUntilDate: "",
    na: [],
    actualExitDate: "",
    classOfAdmission: "",
    priorityDate: "",
    status: "",
    attachments: [
      {
        id: uuidv4(),
        // attachmentName: "",
        // attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  useEffect(() => {
    const baseRules = {
      i94number: { type: "text", required: true },
      attachments: [{ chooseFiles: { type: "file" } }],
    };
    setValidationRules(baseRules);
  }, [formData.attachments.length]);

  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  ///////////////////Handel Save//////////////////////
  console.log("selectedRow", selectedRow);
  const handleSaveI94 = () => {
    const isValid = validateAllFields();

    if (isValid) {
      const userFormData = {
        number: formData.i94number,
        doe: formData.mostRecentDateOfEntry,
        admitDate: formData.admitUntilDate,
        exitDate: formData.actualExitDate,
        admissionClass: formData.classOfAdmission,
        proirityDate: formData.priorityDate,
        status: formData.status,
      };

      const submissionData = filterEmptyValues(userFormData);
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0),
      );
      dispatch(
        updateEmployeeStart({
          coll: "Employee",
          uiid: employeeProfileUiid,
          tab: "i94Tab",
          ret: "i94",
          tPath: edit ? "" : "i94",
          patchId: edit ? selectedRow?._id : "",
          payload: [
            {
              type: edit ? "SET" : "PUSH",
              // value: { "i94.i94": submissionData },
              value: {
                [edit ? "i94.$[elem]" : "i94"]: submissionData,
              },
            },
          ],
          onSuccess: async (payload) => {
            if (cleanAttachments?.length) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: employeeProfileUiid,
                  entity: "employees",
                  category: "i94",
                  coll: "Employee", //WorkAuth
                  doc: cleanAttachments.flatMap((doc) =>
                    doc.chooseFiles.map((file) => {
                      file.id = doc.id;
                      return file;
                    }),
                  ),
                  onSuccess: async (fileData) => {
                    // fileData response will be array format, since uploadType: "multiple"
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Employee",
                        refId: employeeProfileUiid,
                        // refField: "i94.i94.documents",
                        refField: "i94.$[elem].documents",
                        refPatchId: edit
                          ? selectedRow?._id
                          : payload?.data?.targetPatchId,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              parent: { employee: employeeProfileUiid },
                              addedBy: loginUserUiid,
                              docType: "I94",
                              ref: {
                                id: employeeProfileUiid, // parent doc uiid this doc belongs to
                                entity: "Employee", // collection name this doc belongs to
                                path: `i94.${
                                  edit
                                    ? selectedRow?._id
                                    : payload?.data?.targetPatchId
                                }.documents`,
                              },
                              file: cleanAttachments.map((obj) => ({
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                keys: fileData
                                  .filter(
                                    (file) =>
                                      file?.fileRefId === obj.id && file.key,
                                  ) // match and ensure key exists
                                  .map((file) => file.key),
                              })),
                            },
                          ],
                        },
                        //onSuccess: handleModalClose,
                        onSuccess: async () => {
                          dispatch(
                            getEmployeeByUiidStart({
                              uiid: employeeProfileUiid,
                              tab: "i94Tab",
                              ret: "i94 i140",
                              ref: "i94Doc i140Doc",
                            }),
                          );
                          handleModalClose();
                        },
                      }),
                    );
                  },
                }),
              );
            } else {
              dispatch(
                getEmployeeByUiidStart({
                  uiid: employeeProfileUiid,
                  tab: "i94Tab",
                  ret: "i94 i140",
                  ref: "i94Doc i140Doc",
                }),
              );
              handleModalClose();
            }
          },
        }),
      );
    } else {
      showToast("Please fill in all required fields.", "error");
    }
  };
  ///////////////////handel save end////////////////////

  const handleModalClose = () => {
    onClose(true);
    setFormData(initialFormData);
  };
  useEffect(() => {
    if (edit) {
      handleChange("i94number", selectedRow?.number);
      handleChange("mostRecentDateOfEntry", selectedRow?.doe);
      handleChange("admitUntilDate", selectedRow?.admitDate);
      handleChange("actualExitDate", selectedRow?.exitDate);
      handleChange("classOfAdmission", selectedRow?.addmissionClass);
      handleChange("priorityDate", selectedRow?.priorityDate);
      handleChange("status", selectedRow?.status);
    } else {
      setFormData(initialFormData);
    }
  }, [edit, selectedRow]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleModalClose}
      title="Add I-94"
      width="max-w-7xl"
    >
      <div className="">
        {/* <div className="grid grid-cols-3 gap-x-6 gap-y-6 px-2 max-w-7xl"> */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 max-w-7xl">
          <FormFieldSet
            type="text"
            title="I-94 Number"
            placeholder="Enter I-94 Number"
            value={formData.i94number}
            onChange={(value) => handleChange("i94number", value)}
            error={errors.i94number}
            required
          />
          <FormFieldSet
            type="datepicker"
            title="Most recent date of Entry"
            placeholder="Select Most Recent Date Of Entry Date"
            value={formData.mostRecentDateOfEntry}
            onChange={(value) => handleChange("mostRecentDateOfEntry", value)}
            error={errors.mostRecentDateOfEntry}
            showDropdown={false}
          />
          <div className="flex gap-2 items-center">
            <div className="flex-[4]">
              <FormFieldSet
                type="datepicker"
                title="Admit Until Date"
                placeholder="Select Admit Until Date"
                value={formData.admitUntilDate}
                onChange={(value) => handleChange("admitUntilDate", value)}
                error={errors.admitUntilDate}
                disabled={formData.na.includes("1")}
                showDropdown={false}
              />
            </div>
            <div className="flex-[1]">
              <FormFieldSet
                type="checkbox"
                title={""}
                options={[
                  {
                    label: "Na",
                    value: "1",
                  },
                ]}
                values={formData.na || []}
                onChange={(value) => handleChange("na", value)}
              />
            </div>
          </div>
          <FormFieldSet
            type="datepicker"
            title="Actual Exit Date"
            placeholder="Select Actual Exit Date"
            value={formData.actualExitDate}
            onChange={(value) => handleChange("actualExitDate", value)}
            error={errors.actualExitDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title="Class of Admission"
            placeholder="Select Class Of Admission"
            value={formData.classOfAdmission}
            onChange={(value) => handleChange("classOfAdmission", value)}
            error={errors.classOfAdmission}
            options={WADocType}
          />
          <FormFieldSet
            type="datepicker"
            title="Priority Date"
            placeholder="Select Priority Date"
            value={formData.priorityDate}
            onChange={(value) => handleChange("priorityDate", value)}
            error={errors.priorityDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title="Status"
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
            options={WADocStatus}
          />
        </div>

        <div className="mt-3 mb-1">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title="Attachments" tag="h6" />
              </div>
            }
          />
        </div>
        <Divider />
        {edit && (
          <DocumentsList
            data={transformFiles(selectedRow?.documents || [])}
            type="inner"
          />
        )}
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(newAttachments) =>
            setFormData({ ...formData, attachments: newAttachments })
          }
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
        />
        <div></div>
        <div className="flex gap-3 justify-end my-6">
          <Button
            title="Cancel"
            variant="outlined"
            onClick={handleModalClose}
          />
          <Button title="Save" onClick={handleSaveI94} />
        </div>
      </div>
      <Backdrop isOpen={false}>
        <LogoLoader />
      </Backdrop>
    </Modal>
  );
};

export default I94Modal;
